// start:ng42.barrel
export * from './ITranslation';
// end:ng42.barrel




// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/api/interfaces/Translation/index.ts